/**
 * Supported page action types that can be received from the backend.
 */
export enum PageActionType {
	UpdateReportFilters = 'update_report_filters',
}

/**
 * Action data from backend page_action event
 */
export interface BizyPageAction {
	action: string;
	report_type: string;
	params: Record<string, unknown>;
	report_view: string;
	page_path: string;
}

/**
 * Schema that declares how a page handles params.
 * Reports register this to tell the executor which params are paths vs query params.
 */
export interface PageActionSchema {
	/**
	 * Path parameters: maps report_view values to target paths.
	 * Note: report_view comes from the top-level action data, not from params.
	 * Example: { report_view: { giving_and_receiving: '/admin/reports/participation/giving-and-receiving' } }
	 */
	allowedPathParams?: {
		report_view?: {
			[reportViewValue: string]: string;
		};
	};

	/**
	 * Query parameters: param names that should be updated as URL query params.
	 * These come from action.params (start_date, end_date, etc.)
	 * Example: ['start_date', 'end_date', 'custom_property_group']
	 */
	allowedQueryParams?: string[];
}
